// PrivacyPolicy.js
// Plain content only, no page chrome — see TermsOfService.js's header comment for why (rendered
// inside a Modal from SignupFlow.js, no client-side router in this app).
//
// This is a reasonable starting draft, not legal advice — have an actual lawyer review this
// before it's presented to real paying customers as a binding agreement (particularly if you'll
// have customers or employees located somewhere with specific requirements, e.g. GDPR/CCPA).
import { COLORS } from './theme';

const SECTION_STYLE = { marginBottom: '18px' };
const HEADING_STYLE = { margin: '0 0 6px 0', fontSize: '13px', fontWeight: '700', color: COLORS.text };
const BODY_STYLE = { margin: 0, fontSize: '13px', color: COLORS.textMuted, lineHeight: '1.6' };

function PrivacyPolicy() {
  return (
    <div>
      <p style={{ margin: '0 0 20px 0', fontSize: '11px', color: COLORS.textFaint }}>Last updated: {new Date().toLocaleDateString()}</p>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>What We Collect</h4>
        <p style={BODY_STYLE}>
          Account information (name, email, phone) for you and anyone you add to your company account; the
          business data you enter to use the Service (customers, work orders, estimates, invoices, and
          similar records); and, if you enable location tracking for technicians, GPS
          location data while a shift is active.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>How We Use It</h4>
        <p style={BODY_STYLE}>
          Solely to provide the Service to your company — storing and displaying your data back to you and
          the users you authorize, sending notifications you've opted into, and processing payments you
          initiate through the Service. We don't sell your data or your customers' data to third parties.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>Third-Party Services</h4>
        <p style={BODY_STYLE}>
          Some features rely on third-party providers you choose to connect — for example, Stripe for
          payment processing, QuickBooks for accounting sync, or Google for maps and address lookup. Data
          you send through those integrations is subject to that provider's own privacy policy as well as
          this one.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>Data Storage &amp; Security</h4>
        <p style={BODY_STYLE}>
          Your data is stored using Google Firebase's infrastructure, with access controls that scope each
          company's data to that company's own authorized users. No system is perfectly secure, but we take
          reasonable measures to protect your information from unauthorized access.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>Your Choices</h4>
        <p style={BODY_STYLE}>
          You can review, correct, or delete most of your data directly within the Service. You can request
          a full export or deletion of your company's data by contacting us. Location tracking (where
          offered) can be turned off at any time from Settings.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>Data Retention</h4>
        <p style={BODY_STYLE}>
          We keep your data for as long as your account is active. If you close your company account, most
          of your data (work orders, customers, schedules, photos, and the rest) is permanently deleted 30
          days later, unless you cancel the deletion before then. Financial records (invoices, estimates,
          and payments) are retained for 7 years after that for tax and accounting compliance, then deleted
          automatically.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>Contact</h4>
        <p style={BODY_STYLE}>
          Questions about this policy or requests regarding your data can be sent to the email address
          provided to you when your account was set up.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
